module.exports = __webpack_public_path__ + "media/images/arrow_right-e3fcbfdf.svg";